<template>
  <div class="navbar flex">
    <!-- <bread-crumb class="fl"></bread-crumb> -->
    <div class="flexauto leftnav">
<!--            <span @click.stop="showimg">-->
<!--                <img src="../../../assets/othericon/icon_download_16@2x.png" alt="">-->
<!--                下载超级ZO</span>-->

<!--      <span>-->
<!--                <img src="../../../assets/othericon/icon_contact_16@2x.png" alt="">-->
<!--                联系我们：400-100-1111-->
<!--            </span>-->
<!--      <span>-->
<!--                <img src="../../../assets/othericon/icon_message_16@2x.png" alt="">-->
<!--                我的消息-->
<!--            </span>-->
<!--      <span>-->
<!--                <img src="../../../assets/othericon/icon_feedback_16@2x.png" alt="">-->
<!--                意见反馈箱-->

<!--            </span>-->

    </div>
    <div class="flexnone right-menu">
      <!-- <span class="job">{{'您好，'+center+departName}}</span> -->
      <Dropdown trigger="click" @on-click="getOut">
                <span style="line-height: 28px;" class="name">
                    {{name}}，欢迎回来
                    <Icon type="arrow-down-b"></Icon>
                </span>
        <DropdownMenu slot="list">
          <DropdownItem name="logout">退出</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import BreadCrumb from 'components/BreadCrumb/index';
  import {mapGetters} from 'vuex';
  import zoimg from '../../../assets/zo.jpg'

  export default {
    computed: {
      ...mapGetters(['name',])
    },
    components: {
      BreadCrumb
    },
    data(){
      return {
        zoimg:zoimg
      }

    },
    created() {
      this.init();
    },
    methods: {
      showimg(){
        this.$showImg(this.zoimg);

      },
      getOut(name) {
        if (name === 'logout') {
          this.$store.dispatch('Logout').then(res => {
            location.reload();
          })
        }
      },
      init() {
        // this.$store.dispatch('Userinfo').then(res => {
        //
        // })
      }
    }
  }
</script>

<style lang="css" scoped>
  .leftnav {
    color: #444444;
  }

  .leftnav span {
    padding: 0 50px;
    border-right: 1px solid #4444;

  }

  .leftnav span:last-child {
    border-right: none;

  }

  .leftnav span:first-child {
    padding-left: 0;

  }

  .leftnav img {
    width: 18px;
    /*line-height: 62px;*/
    vertical-align: middle;
    /*margin-right: 5px;*/

  }

  .navbar {
    height: 62px;
    line-height: 62px;
    padding: 0 32px 0 32px;
    width: 100%;
  }

  .name {
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #CFA868;
    cursor: pointer;
  }

  .job {
    font-size: 12px;
    margin-right: 10px;
  }
</style>
